"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#AgentDomainAsset',
    assetType: 'AgentDomain'
  },
  owner: {
    gusTeam: 'MuleSoft AI',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00EE00001PNBn4YAH/view'
  },
  name: 'Agent Domain',
  pluralName: 'Agent Domains',
  featureFlag: 'agent-domain-enabled',
  publication: {
    inferredBy: [{
      classifiers: ['agent-domain']
    }, {
      typeProperty: 'agent-domain'
    }],
    files: [{
      id: 'agent-domain',
      classifier: 'agent-domain',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }, {
      id: 'single-agent-domain',
      classifier: 'agent-domain',
      mainFileLocationProperty: 'mainFile',
      packaging: 'yaml'
    }, {
      id: 'light-agent-domain',
      classifier: 'light-agent-domain',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }, {
      id: 'fat-agent-domain',
      classifier: 'fat-agent-domain',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['single-agent-domain'],
      requiredProperties: ['mainFile']
    }],
    extensionPoints: [{
      name: 'filesGenerator',
      config: {
        outputFileIds: ['light-agent-domain', 'fat-agent-domain']
      }
    }]
  },
  keywords: ['agent-domain', 'agent', 'domain']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map